import AwardStyleBadge from "@/components/schools/rewards/AwardStyleBadge";
import { rewardSummary } from "@/lib/prizes";

/** A compact, read-only list: "Pizza party · At $500 raised". */
export default function RewardList({ rewards }) {
  return (
    <ul className="mt-1 space-y-1">
      {rewards.map((reward) => (
        <li key={reward.id} className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
          <span className="font-medium text-foreground">{reward.prize}</span>
          <span className="text-xs">{rewardSummary(reward)}</span>
          <AwardStyleBadge style={reward.award_style} />
        </li>
      ))}
    </ul>
  );
}
